import React from 'react';
import { createIcon } from '../../../utils/createIcon';

const IconCircleAccount = createIcon({
  path: (
    <>
      <path
        d="M12 23.1426C18.1541 23.1426 23.1429 18.1538 23.1429 11.9998C23.1429 5.84576 18.1541 0.856934 12 0.856934C5.846 0.856934 0.857178 5.84576 0.857178 11.9998C0.857178 18.1538 5.846 23.1426 12 23.1426Z"
        stroke="#CFDAEC"
        strokeWidth="1.5"
      />
      <path
        d="M9.97863 12.4844C9.12551 11.8607 8.57136 10.8524 8.57136 9.7147C8.57136 7.82116 10.1064 6.28613 11.9999 6.28613C13.8935 6.28613 15.4285 7.82116 15.4285 9.7147C15.4285 10.8524 14.8743 11.8607 14.0212 12.4844C15.46 12.7885 16.6437 13.4433 17.5621 14.4535C17.6635 14.5651 17.7142 14.7113 17.7142 14.8576V17.1433C17.7142 17.4589 17.4816 17.7147 17.1947 17.7147H6.80513C6.51822 17.7147 6.28564 17.4589 6.28564 17.1433V14.8576C6.28564 14.7113 6.33636 14.5651 6.4378 14.4535C7.35617 13.4433 8.53991 12.7885 9.97863 12.4844Z"
        fill="#3D6CB4"
      />
      <path
        d="M16.6754 15.1009C15.5763 13.9902 14.0268 13.4287 12 13.4287C9.97326 13.4287 8.42373 13.9902 7.32471 15.1009L7.32471 16.5716H16.6754V15.1009Z"
        fill="#E6ECF5"
      />
      <path
        d="M11.9999 12.0001C13.2623 12.0001 14.2857 10.9768 14.2857 9.71443C14.2857 8.45206 13.2623 7.42871 11.9999 7.42871C10.7376 7.42871 9.71423 8.45206 9.71423 9.71443C9.71423 10.9768 10.7376 12.0001 11.9999 12.0001Z"
        fill="#E6ECF5"
      />
    </>
  ),
});

export default IconCircleAccount;
